
const G = 10
const DAMPING_RATIO = 0.02
const MAX_AERFA = [
    { 'idensity ': 6, 'freq': 0.04, 'rare': 0.28 },
    { 'idensity ': 7, 'freq': 0.08, 'rare': 0.50 },
    { 'idensity ': 7.5, 'freq': 0.12, 'rare': 0.72 },
    { 'idensity ': 8, 'freq': 0.16, 'rare': 0.9 },
    { 'idensity ': 8.5, 'freq': 0.24, 'rare': 1.2 },
    { 'idensity ': 9, 'freq': 0.32, 'rare': 1.4 },
]


// 地震作用计算：方法一
export function seismCalculation_method1(params_seism, params_force, amplifcation) {
    // 1、常量参数定义

    // 2 、地震参数计算
    let G_top = (params_seism.hub_weight.value) * G
    let G_middle = (params_seism.tower_weight.value) * G
    let T = params_seism.the_first_frequency.value === 0 ? 5 : 1 / params_seism.the_first_frequency.value
    let gama = 0.9 + (0.05 - DAMPING_RATIO) / (0.3 + 6 * DAMPING_RATIO)
    let eta1 = Math.max(0, 0.02 + (0.05 - DAMPING_RATIO) / (4 + 32 * DAMPING_RATIO))
    let eta2 = Math.max(0.55, 1 + (0.05 - DAMPING_RATIO) / (0.08 + 1.6 * DAMPING_RATIO))

    let aerfa_max_freq = MAX_AERFA[params_seism.seism_indensity.value.toString()].freq
    let aerfa_max_rare = MAX_AERFA[params_seism.seism_indensity.value.toString()].rare

    let lamda_ratio = get_lamda_ratio(T);

    // 3、多遇地震作用计算
    let eh1_freq = min_horizontal_seism(
        lamda_ratio, aerfa_max_freq,
        G_top, G_middle,
        params_seism.hub_height.value
    )
    let eh2_freq = horizontal_seism(
        aerfa_max_freq, params_seism.seism_period.value,
        T, gama, eta1, eta2, G_top, G_middle,
        params_seism.hub_height.value
    )
    params_force.small_eq.fr.value = Math.round(amplifcation * Math.max(eh1_freq.Fek, eh2_freq.Fek) * 100) / 100
    params_force.small_eq.mr.value = Math.round(amplifcation * Math.max(eh1_freq.Mek, eh2_freq.Mek) * 100) / 100
    params_force.small_eq.fz.value = Math.round(amplifcation * vertical_seism(aerfa_max_freq, G_top, G_middle) * 100) / 100

    // 4、罕遇地震作用计算
    let eh1_rare = min_horizontal_seism(
        lamda_ratio, aerfa_max_rare,
        G_top, G_middle,
        params_seism.hub_height.value
    )
    let eh2_rare = horizontal_seism(
        aerfa_max_rare, params_seism.seism_period.value + 0.05,
        T, gama, eta1, eta2, G_top, G_middle,
        params_seism.hub_height.value
    )
    params_force.large_eq.fr.value = Math.round(amplifcation * Math.max(eh1_rare.Fek, eh2_rare.Fek) * 100) / 100
    params_force.large_eq.mr.value = Math.round(amplifcation * Math.max(eh1_rare.Mek, eh2_rare.Mek) * 100) / 100
    params_force.large_eq.fz.value = Math.round(amplifcation * vertical_seism(aerfa_max_rare, G_top, G_middle) * 100) / 100
}

// 地震作用计算：方法一
export function seismCalculation_method2(params_temp_force, params_force, amplifcation) {
    let keys = ['fr', 'mr', 'fz', 'mz'];

    // 1、荷载变量定义
    let eq = [params_force.small_eq, params_force.large_eq];
    let eq_temp = [params_temp_force.small_eq_temp, params_temp_force.large_eq_temp];

    // 2 、水平地震作用计算
    for (let j = 0; j < eq.length; j++) {
        for (let i = 0; i < keys.length; i++) {
            eq[j][keys[i]].value = Math.round(amplifcation * eq_temp[j][keys[i]].value * 100) / 100;
        }
    }
}


// 疲劳荷载计算函数
export function fatigueCalculation(params_temp_fatigue, fatigue_upper, fatigue_lower) {
    let key = ['fx', 'fy', 'fz', 'mx', 'my', 'mz']
    let upper = {};
    let lower = {};

    for (let i = 0; i < key.length; i++) {
        upper[key[i]] = params_temp_fatigue.even_load[key[i]].value + Math.abs(params_temp_fatigue.amplitude[key[i]].value) / 2
        lower[key[i]] = params_temp_fatigue.even_load[key[i]].value - Math.abs(params_temp_fatigue.amplitude[key[i]].value) / 2
    }

    fatigue_upper.fr.value = Math.round(Math.sqrt(Math.pow(upper.fx, 2) + Math.pow(upper.fy, 2)) * 100) / 100
    fatigue_upper.mr.value = Math.round(Math.sqrt(Math.pow(upper.mx, 2) + Math.pow(upper.my, 2)) * 100) / 100
    fatigue_upper.fz.value = Math.round(upper.fz * 100) / 100
    fatigue_upper.mz.value = Math.round(upper.mz * 100) / 100

    fatigue_lower.fr.value = fatigue_upper.fr.value === 0 ? Math.sqrt(Math.pow(lower.fx, 2) + Math.pow(lower.fy, 2)) : (upper.fx * lower.fx + upper.fy * lower.fy) / (fatigue_upper.fr.value)
    fatigue_lower.fr.value = Math.round(fatigue_lower.fr.value * 100) / 100
    fatigue_lower.mr.value = fatigue_upper.mr.value === 0 ? Math.sqrt(Math.pow(lower.mx, 2) + Math.pow(lower.my, 2)) : (upper.mx * lower.mx + upper.my * lower.my) / (fatigue_upper.mr.value)
    fatigue_lower.mr.value = Math.round(fatigue_lower.mr.value * 100) / 100
    fatigue_lower.fz.value = Math.round(lower.fz * 100) / 100
    fatigue_lower.mz.value = Math.round(lower.mz * 100) / 100
}

//快速计算时，标准荷载组合
// export function nominalCombination(params_force, params_geometry, params_soil_extra) {
//     let R = params_geometry.find((obj) => obj.name === "R");
//     let R1 = params_geometry.find((obj) => obj.name === "R1");
//     let R2 = params_geometry.find((obj) => obj.name === "R2");
//     let H1 = params_geometry.find((obj) => obj.name === "H1");
//     let H2 = params_geometry.find((obj) => obj.name === "H2");
//     let H3 = params_geometry.find((obj) => obj.name === "H3");
//     let H = (H1.value + H2.value + H3.value);
//     let backFillRatio = params_geometry.find((obj) => obj.name === "backFillRatio");

//     let vol_base = Math.PI * Math.pow(R.value, 2) * H1.value +
//         ((H2.value) / 3) *Math.PI * (Math.pow(R.value, 2) + Math.pow(R1.value, 2) +R.value * R1.value) +
//         H3.value * Math.PI * Math.pow(R2.value, 2)
//     let h_water = params_soil_extra.water_depth.value>(H.value-backFillRatio.slopY)?0:(H.value-backFillRatio.slopY)-params_soil_extra.water_depth.value
//     let base_weight = vol_base * 25 + backFillRatio.vol*params_soil_extra.backfill_density.value - h_water*10*Math.PI * Math.pow(R.value, 2) 
//     let eq_no = [params_force.normal, params_force.extreme]
//     let eq = [params_force.small_eq, params_force.large_eq]
//     let norminal_force = []
//     for (let i = 0; i < eq_no.length; i++) {
//             norminal_force.push({
//                 fr: Math.round(eq_no[i].fr.value * 100) / 100,
//                 mr: Math.round((eq_no[i].mr.value+eq_no[i].fr.value*H) * 100) / 100,
//                 fz: Math.round((eq_no[i].fz.value+base_weight) * 100) / 100,
//                 mz: Math.round(eq_no[i].mz.value * 100) / 100
//             })
//     }
// }


// 地震作用计算所需的函数（内部函数）~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


// 1、计算水平地震影响系数值
function get_aerfa(aerfa_max, Tg, T, gama, eta1, eta2) {
    let aerfa = 0;
    if (T <= 0.1) {
        aerfa = (0.45 + (eta2 - 0.45) / 0.1 * T) * aerfa_max;
    } else if (T <= Tg) {
        aerfa = eta2 * aerfa_max;
    } else if (T <= 5 * Tg) {
        aerfa = Math.pow(Tg / T, gama) * eta2 * aerfa_max;
    } else {
        aerfa = (eta2 * Math.pow(0.2, gama) - eta1 * (T - 5 * Tg)) * aerfa_max;
    }
    return aerfa;
}

// 2、计算水平地震作用
function horizontal_seism(aerfa_max, Tg, T, gama, eta1, eta2, G_top, G_middle, hub_height, T_structure = 0) {

    // 计算顶部附加系数
    let T1 = T_structure === 0 ? T : T_structure;
    let top_add_coeff = T1 <= 1.4 * Tg ? 0 : () => {
        if (Tg <= 0.35) {
            return 0.08 * T1 + 0.07;
        } else if (Tg <= 0.55) {
            return 0.08 * T1 + 0.01;
        } else {
            return 0.08 * T1 - 0.02;
        }
    }

    // 计算地震作用
    let Fek = get_aerfa(aerfa_max, Tg, T, gama, eta1, eta2) * (G_top + G_middle) * 0.85;
    let Fek_middle = Fek * (1 - top_add_coeff()) * ((G_middle * hub_height / 2) / (G_top * hub_height + G_middle * hub_height / 2));
    let Fek_top = Fek - Fek_middle;
    let Mek = Fek_top * hub_height + Fek_middle * hub_height / 2;

    return { Fek, Mek };

}

// 3、按最小剪重比计算水平地震作用
function get_lamda_ratio(T) {   //定义剪重比函数，避免大小震重复计算, 大小震相同
    let lamda = 0;
    if (T < 3.5) {
        lamda = 0.2;
    } else if (T <= 5) {
        lamda = (0.2 + (0.15 - 0.2) / 1.5 * (T - 3.5));
    } else {
        lamda = 0.15;
    }
    return lamda;
}

function min_horizontal_seism(lamda_ratio, aerfa_max, G_top, G_middle, hub_height) {
    let lamda = aerfa_max * lamda_ratio
    let Fek_top = lamda * G_top
    let Fek_middle = lamda * G_middle
    let Fek = Fek_top + Fek_middle
    let Mek = Fek_top * hub_height + Fek_middle * hub_height / 2

    return { Fek, Mek };
}

// 4、计算竖直地震作用
function vertical_seism(aerfa_max, G_top, G_middle) {
    return 1.5 * (0.65 * aerfa_max) * ((G_top + G_middle) * 0.75);
}

